"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHomePath = void 0;
const react_1 = require("react");
const utils_1 = require("../../utils");
const useHomePath = ({ reseller }) => {
    return (0, react_1.useMemo)(() => `/${(reseller === null || reseller === void 0 ? void 0 : reseller.catalogSlug) || utils_1.envConfig.genericUrl}`, [reseller === null || reseller === void 0 ? void 0 : reseller.catalogSlug]);
};
exports.useHomePath = useHomePath;
